(() => {
  const body = document.body;

  if (!body) return;

  const getShiprocketCartHandler = () => {
    const handler = window.shiprocketCheckoutEvents?.buyCart || window.HeadlessCheckout?.checkout;
    return typeof handler === 'function' ? handler : null;
  };

  const gravixShiprocketCartCheckout = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const invoke = () => {
      const handler = getShiprocketCartHandler();
      if (!handler) return false;
      handler(event);
      return true;
    };

    if (invoke()) return;

    let attempts = 0;
    const retry = () => {
      if (invoke()) return;
      attempts += 1;
      if (attempts < 50) window.setTimeout(retry, 100);
    };
    window.setTimeout(retry, 0);
  };

  window.gravixShiprocketCartCheckout = gravixShiprocketCartCheckout;

  const ensureNativeCheckout = () => {
    document.querySelectorAll('[data-v2-cart-cta]').forEach((container) => {
      const isDrawer = Boolean(container.closest('.gv2-cart-drawer'));
      const checkoutId = isDrawer ? 'CartDrawer-Checkout' : 'checkout';
      const existingButton = container.querySelector(`#${checkoutId}`);

      if (existingButton) {
        existingButton.hidden = false;
        existingButton.style.removeProperty('display');
        return;
      }

      const checkoutForm = isDrawer
        ? container.closest('.gv2-cart-drawer')?.querySelector('#CartDrawer-Form')
        : document.querySelector('#cart');
      if (!checkoutForm) return;

      const checkoutButton = document.createElement('button');
      checkoutButton.type = 'button';
      checkoutButton.id = checkoutId;
      checkoutButton.className = 'cart__checkout-button button';
      checkoutButton.name = 'checkout';
      checkoutButton.setAttribute('form', checkoutForm.id);
      checkoutButton.setAttribute('onclick', 'gravixShiprocketCartCheckout(event)');
      checkoutButton.textContent = container.dataset.v2CheckoutLabel || 'Proceed to secure checkout';
      container.append(checkoutButton);
    });
  };

  const wireCheckoutButtons = () => {
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((button) => {
      if (button.dataset.gravixShiprocketCheckout === 'true') return;
      button.dataset.gravixShiprocketCheckout = 'true';
      button.setAttribute('onclick', 'gravixShiprocketCartCheckout(event)');
      if (button.tagName === 'BUTTON') button.type = 'button';
    });
  };

  const hideDuplicateCheckoutControls = () => {
    const cartPage = body.classList.contains('gravix-cart-v2');
    const selector = cartPage
      ? '.shiprocket-headless, .btn-buy-now, [class*="shiprocket"], [id*="shiprocket"]'
      : 'cart-drawer .shiprocket-headless, cart-drawer .btn-buy-now, cart-drawer [class*="shiprocket"], cart-drawer [id*="shiprocket"]';

    document.querySelectorAll(selector).forEach((element) => {
      element.hidden = true;
      element.style.setProperty('display', 'none', 'important');
    });
  };

  let scheduled = false;
  const scheduleCleanup = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      hideDuplicateCheckoutControls();
      ensureNativeCheckout();
      wireCheckoutButtons();
    });
  };

  hideDuplicateCheckoutControls();
  ensureNativeCheckout();
  wireCheckoutButtons();
  new MutationObserver(scheduleCleanup).observe(body, { childList: true, subtree: true });
})();
